import { a as o, j as e } from "../../../../../emotion-react-jsx-runtime.browser.esm-CsRinUqv.js";
import { useState as C } from "react";
import t from "../../../../string-table.js";
import { Colors as r } from "../../../../1-foundations/Colors/Colors.js";
import { I as l } from "../../../../../Icon-CAQ-6E_J.js";
import { H as R } from "../../../../../FeatureFlagProvider-DyczYY1y.js";
import "@ionic/react";
import "../../../../../react-paginate-Lh5zQzpz.js";
import "../../../LoadingInterstitial/LoadingInterstitial.js";
import { Accordion as d } from "../../../Acccordion/Accordion.js";
import "../../../../contexts/DesignSystemProvider/DesignSystemProvider.js";
import '../../../../../css/SwingHero.css';const W = "_container_10usu_1", p = "_statusSection_10usu_12", G = "_statusTitle_10usu_21", A = "_statusContainer_10usu_27", h = "_status_10usu_12", g = "_subtext_10usu_41", x = "_accordionContent_10usu_48", U = "_accList_10usu_59", B = "_accListItem_10usu_69", b = "_accListDescription_10usu_76", f = "_accListItemIcon_10usu_82", P = "_accListFooter_10usu_89", c = {
  container: W,
  statusSection: p,
  statusTitle: G,
  statusContainer: A,
  status: h,
  subtext: g,
  accordionContent: x,
  accList: U,
  accListItem: B,
  accListDescription: b,
  accListItemIcon: f,
  accListFooter: P
};
function q(n) {
  const {
    subDaysWorked: _,
    score: s,
    isSwingHero: i,
    isSwingHeroEligible: I,
    isHourly: O
  } = n, S = D({
    isSwingHero: i,
    isSwingHeroEligible: I
  }), {
    subtext: u,
    statusText: L,
    statusIcon: T
  } = M(S), E = F(S, O), [N, m] = C(!0);
  function H() {
    m(!N);
  }
  return /* @__PURE__ */ o("div", {
    className: c.container,
    children: [/* @__PURE__ */ o("div", {
      className: c.statusSection,
      children: [/* @__PURE__ */ e("p", {
        className: c.statusTitle,
        children: t("SWING_HERO_YOUR_STATUS")
      }), /* @__PURE__ */ o("div", {
        className: c.statusContainer,
        children: [T, /* @__PURE__ */ e("p", {
          className: c.status,
          children: L
        })]
      }), u && /* @__PURE__ */ e("p", {
        className: c.subtext,
        children: u
      })]
    }), /* @__PURE__ */ e(d, {
      title: E.title,
      isOpen: N,
      onToggle: H,
      style: {
        borderBottom: "0px",
        width: "100%",
        padding: "0px"
      },
      headerStyle: {
        padding: "0px"
      },
      titleStyle: {
        fontSize: 14,
        fontWeight: 600,
        lineHeight: "24px"
      },
      children: /* @__PURE__ */ e("div", {
        className: c.accordionContent,
        children: E.content
      })
    })]
  });
}
function D(n) {
  const {
    isSwingHero: _,
    isSwingHeroEligible: s
  } = n;
  return s === !1 ? "ineligible" : _ ? "hero" : "eligible";
}
function M(n) {
  switch (n) {
    case "hero":
      return {
        statusText: `${t("SUB_PROFILE_CONTACT_SWING")} ${t("SUB_PROFILE_CONTACT_HERO")}`,
        subtext: "",
        statusIcon: /* @__PURE__ */ e(l, {
          name: "Swing Hero"
        })
      };
    case "eligible":
      return {
        statusText: t("SWING_HERO_SWING_SUB"),
        subtext: t("SWING_HERO_ELIGIBLE_SUBTEXT"),
        statusIcon: /* @__PURE__ */ e(l, {
          name: "Star Unfilled",
          color: r.blue500
        })
      };
    case "ineligible":
      return {
        statusText: t("SWING_HERO_SWING_SUB"),
        subtext: t("SWING_HERO_INELIGIBLE_SUBTEXT"),
        statusIcon: null
      };
    default:
      return {
        statusText: t("SWING_HERO_SWING_SUB"),
        subText: "",
        statusIcon: null
      };
  }
}
function F(n, _) {
  const s = t("SWING_HERO_SKILL_BUILDER_URL"), i = R(_ ? t("SWING_HERO_SUPPORT_ARTICLE_LINK_W2") : t("SWING_HERO_SUPPORT_ARTICLE_LINK_1099")), I = R("/hc/en-us/requests/new");
  switch (n) {
    case "hero":
      return {
        title: t("SWING_HERO_MAINTAIN_STATUS_TITLE"),
        content: a([{
          iconName: "Check Circle",
          text: t("SWING_HERO_MAINTAIN_PROFESSIONAL_BEHAVIOR")
        }, {
          iconName: "Check Circle",
          text: t("SWING_HERO_IMPROVE_SKILLS_WITH_SKILL_BUILDER", {
            skillBuilderUrl: s
          })
        }, {
          listDescription: t("SWING_HERO_QUALIFYING_FOR_DESCRIPTION")
        }, {
          iconName: "Star Circle",
          text: t("SWING_HERO_PRIORITY_ACCESS_PERK")
        }, {
          iconName: "Star Circle",
          text: t("SWING_HERO_INCREASED_EARNINGS_PERK")
        }], [t("SWING_HERO_LEARN_MORE_ABOUT_HEROES", {
          heroesUrl: i
        })])
      };
    case "eligible":
      return {
        title: t("SWING_HERO_HOW_TO_BECOME_TITLE"),
        content: a([{
          iconName: "Check Circle",
          text: t("SWING_HERO_MAINTAIN_PROFESSIONAL_BEHAVIOR")
        }, {
          iconName: "Check Circle",
          text: t("SWING_HERO_IMPROVE_SKILLS_WITH_SKILL_BUILDER", {
            skillBuilderUrl: s
          })
        }, {
          listDescription: t("SWING_HERO_TO_QUALIFY_FOR_DESCRIPTION")
        }, {
          iconName: "Star Circle",
          text: t("SWING_HERO_PRIORITY_ACCESS_PERK")
        }, {
          iconName: "Star Circle",
          text: t("SWING_HERO_INCREASED_EARNINGS_PERK")
        }], [t("SWING_HERO_LEARN_MORE_ABOUT_HEROES", {
          heroesUrl: i
        })])
      };
    case "ineligible":
      return {
        title: t("SWING_HERO_TIPS_TITLE"),
        content: a([{
          iconName: "Check Circle",
          iconColor: r.black,
          text: t("SWING_HERO_INELIGIBLE_LIST_FIRST_ITEM")
        }, {
          iconName: "Check Circle",
          iconColor: r.black,
          text: t("SWING_HERO_INELIGIBLE_LIST_SECOND_ITEM")
        }, {
          iconName: "Check Circle",
          iconColor: r.black,
          text: t("SWING_HERO_IMPROVE_SKILLS_WITH_SKILL_BUILDER", {
            skillBuilderUrl: s
          })
        }], [t("SWING_HERO_CONTACT_SUPPORT_QUESTIONS", {
          supportUrl: I
        }), t("SWING_HERO_LEARN_MORE_ABOUT_HEROES", {
          heroesUrl: i
        })])
      };
    default:
      return {
        title: t("SWING_HERO_HOW_TO_BECOME_TITLE"),
        content: a([], [""])
      };
  }
}
function a(n, _) {
  return /* @__PURE__ */ o("div", {
    children: [/* @__PURE__ */ e("ul", {
      className: c.accList,
      children: n.map((s, i) => "listDescription" in s ? /* @__PURE__ */ e("div", {
        className: c.accListDescription,
        children: /* @__PURE__ */ e("p", {
          children: s.listDescription
        })
      }, i) : /* @__PURE__ */ o("li", {
        className: c.accListItem,
        children: [/* @__PURE__ */ e("div", {
          className: c.accListItemIcon,
          children: /* @__PURE__ */ e(l, {
            name: s.iconName,
            color: s.iconColor || r.green500
          })
        }), /* @__PURE__ */ e("span", {
          dangerouslySetInnerHTML: {
            __html: s.text
          }
        })]
      }, i))
    }), _.map((s, i) => /* @__PURE__ */ e("div", {
      className: c.accListFooter,
      children: /* @__PURE__ */ e("p", {
        dangerouslySetInnerHTML: {
          __html: s
        }
      })
    }, i))]
  });
}
export {
  q as SwingHero
};
